//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import React from "react";
import { QueryRenderer, ReadyState } from "react-relay";
// pricing-grid imports
import { IRendererProps, IRendererState } from "./PricingGridRenderer.d";
import { pricingGridRendererQuery } from "./PricingGridRenderer.gql";
import { OrgPricingGrid } from "./org-pricing-grid";
// other components
import { Loader } from "@clockwise/web-commons/src/components/loader";
// util
import { handleReadyStateError } from "@util/relay.util";
import { track, TrackingEvents } from "@util/analytics.util";

//////////////////
// COMPONENT
//////////////////
export class PricingGridRenderer extends React.Component<IRendererProps, IRendererState> {
  // ~-~-~-~-~-~-~-
  // Setup
  // ~-~-~-~-~-~-~-
  // private refetchInterval?: ReturnType<typeof setInterval>;
  private shouldForce = true;

  private cachedOrg?: ISchema.IOrg;

  constructor(props: IRendererProps) {
    super(props);
    this.state = {
      key: 0,
      selectedTeamId: props.teamId,
      loading: false,
    };
  }

  // ~-~-~-~-~-~-~-
  // Life-Cycle
  // ~-~-~-~-~-~-~-
  public componentDidMount() {
    // this.refetchInterval = setInterval(() => {
    //   this.refetch();
    // }, 30 * 60 * 1000);
    track(TrackingEvents.PRICING.VIEW_PRICING_GRID);
  }

  // public componentWillUnmount() {
  //   if (this.refetchInterval) {
  //     clearInterval(this.refetchInterval);
  //     delete this.refetchInterval;
  //   }
  // }

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-
  private refetch = () => {
    this.shouldForce = true;
    this.setState({ key: this.state.key + 1 });
  };

  private onChangeLoading = (loading: boolean) => {
    this.setState({ loading });
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const { orgRelayId } = this.props;
    const fetchVariables = { orgRelayId };

    return (
      <QueryRenderer
        key={this.state.key}
        environment={this.props.environment}
        query={pricingGridRendererQuery}
        variables={fetchVariables}
        cacheConfig={{ force: this.shouldForce }}
        render={(readyState: ReadyState) => {
          // check for error or show a loader for first load
          if (readyState.error) {
            handleReadyStateError(readyState.error, "PricingGridRenderer");
            return null;
          }

          const org =
            (readyState && readyState.props && (readyState.props.org as ISchema.IOrg)) || null;

          if (org) {
            this.cachedOrg = org;
          }

          if (!this.cachedOrg || this.state.loading) {
            return <Loader />;
          }

          this.shouldForce = false;

          return (
            <OrgPricingGrid
              org={this.cachedOrg}
              refetch={this.refetch}
              isDialog={this.props.isDialog}
              onChangeDialogView={this.props.onChangeDialogView}
              billingRecurrence={this.props.billingRecurrence}
              onChangeBillingRecurrence={this.props.onChangeBillingRecurrence}
              onChangeLoading={this.onChangeLoading}
            />
          );
        }}
      />
    );
  }
}
